// extracted by mini-css-extract-plugin
export default {"rum-snippet-textarea":"rum-snippet-textarea-OoBXh","variant-help-link":"variant-help-link-oaesC"};